import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "root-element",
    style: { "background-color": "#ffffff" }
};
const _hoisted_2 = { id: "app" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("link", {
    rel: "stylesheet",
    href: "https://www.w3schools.com/w3css/4/w3.css"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DynamicForm = _resolveComponent("DynamicForm");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_DynamicForm)
        ])
    ]));
}
